import React, { useState } from "react";

import { Tooltip, Avatar } from "@mui/material";
import ReportModal from "./ReportModal";

const ProductTimelineAccordion = ({
  product,
  job,
  CampaignDetails,
  getCampaignDetails,
}) => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  //  ONLY CHANGE: Find the best job - Recce if completed, otherwise Installation
  const matchingJob = (() => {
    const recceJob = job?.find(
      (ele) => ele?.serviceType === "0");
    const installationJob = job?.find(
      (ele) => ele?.serviceType === "1");
    
    // If Recce is completed (status 2), use it
    if (recceJob?.status === 2) return recceJob;
    
    // Otherwise use Installation job
    if (installationJob) return installationJob;
    
    // Fallback
    return job?.[0];
  })();

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-4 my-8 border-b border-gray-300 pb-4 px-2">
      {/* Accordion */}

      <div className="font-medium flex justify-start text-gray-700 text-sm col-span-1">
        {product?.productType || "Product"}
      </div>

      <div className="mx-0 md:mx-3 col-span-2 order-3 md:order-none">
        {/* Timeline UI */}
        <ol className="items-center sm:flex">
          {/* work initiated */}
          {job[0]?.serviceType === "0" &&
          (job[0]?.installationPartnerId || job[0].vendorId) ? (
            <li className="relative mb-6 sm:mb-0">
              <div className="z-15 flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full shrink-0">
                <img
                  src="/assests/images/Campaigndash/Vector.png"
                  alt="vector"
                />
              </div>
              <div className="hidden absolute top-2.5 sm:flex w-[84%] ml-6 z-3 h-0.5 bg-blue-500"></div>
              <div className="mt-2 sm:pe-8 w-36">
                <p className="text-sm font-normal text-gray-500 text-start">
                  Work Initiated
                </p>
              </div>
            </li>
          ) : (
            <li className="relative mb-6 sm:mb-0">
              <div className="flex items-center">
                <div className="z-10 flex items-center justify-center w-6 h-6 border border-blue-500 rounded-full shrink-0">
                  <img
                    src="/assests/images/Campaigndash/circle.png"
                    alt="circle"
                  />
                </div>
                <div className="hidden sm:flex w-full bg-gray-500 h-0.5"></div>
              </div>
              <div className="mt-2 sm:pe-8 w-36">
                <p className="text-sm font-normal text-gray-500 text-start">
                  Work Initiated
                </p>
              </div>
            </li>
          )}

          {/* recce */}
          {job[0]?.servicesNeeded?.includes("Recce") && (
            <>
              {job
                ?.filter(
                  (ele) =>
                    ele?.serviceType === "0" && ele?.installationPartnerId,
                )
                .map((ele) => (
                  <li className="relative mb-6 sm:mb-0" key={ele._id}>
                    <div className="flex items-center relative w-20 bottom-[1rem]">
                      <Tooltip
                        title={
                          <div className="text-white rounded-lg p-2">
                            <div className="flex items-center mb-2">
                              <Avatar
                                sx={{
                                  bgcolor: "#3b82f6",
                                  width: 60,
                                  height: 60,
                                }}
                                variant="rounded"
                              >
                                {ele?.installationPartnerId?.name
                                  ?.charAt(0)
                                  .toUpperCase()}
                              </Avatar>
                              <div className="ml-3">
                                <p className="font-semibold text-white">
                                  IP Name:{" "}
                                  {ele?.installationPartnerId?.name ||
                                    "Unknown"}
                                </p>
                                <p className="text-white">
                                  Total Jobs done:{" "}
                                  <span className="font-bold">240</span>
                                </p>
                                <p className="text-white">
                                  Rating: ⭐{" "}
                                  {ele?.installationPartnerId?.rating || "N/A"}
                                </p>
                              </div>
                            </div>
                          </div>
                        }
                        arrow
                        placement="top"
                      >
                        <img
                          src="/assests/images/Campaigndash/Icon (4).png"
                          className="cursor-pointer"
                          alt="info"
                        />
                      </Tooltip>
                      <div className="hidden sm:flex w-full bg-blue-500 h-0.5"></div>
                    </div>
                  </li>
                ))}

              {/* Status check */}
              {job.filter(
                (ele) => ele?.serviceType === "0" && ele.installationPartnerId,
              ).length > 0 ? (
                job
                  .filter(
                    (ele) =>
                      ele?.serviceType === "0" && ele.installationPartnerId,
                  )
                  .map((ele) => (
                    <React.Fragment key={ele._id}>
                      {ele.status === 2 ? (
                        <li className="relative mb-6 sm:mb-0">
                          <div className="z-10 flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full shrink-0">
                            <img
                              src="/assests/images/Campaigndash/Vector.png"
                              alt="vector"
                            />
                          </div>
                          {(job[0]?.servicesNeeded.includes("Printing") ||
                            job[0]?.servicesNeeded.includes("Fabrication") ||
                            job[0]?.servicesNeeded.includes("Painting")) && (
                            <div className="hidden absolute top-2.5 sm:flex w-[84%] ml-6 z-3 h-0.5 bg-blue-500"></div>
                          )}
                          <div className="mt-2 sm:pe-8 w-36">
                            <p className="text-sm font-normal text-gray-500 text-start">
                              Recce
                            </p>
                          </div>
                        </li>
                      ) : (
                        <li className="relative mb-6 sm:mb-0">
                          <div className="z-15 flex items-center justify-center w-6 h-6 border border-blue-500 rounded-full shrink-0">
                            <img
                              src="/assests/images/Campaigndash/circle.png"
                              alt="circle"
                            />
                          </div>
                          {(job[0]?.servicesNeeded.includes("Printing") ||
                            job[0]?.servicesNeeded.includes("Fabrication") ||
                            job[0]?.servicesNeeded.includes("Painting")) && (
                            <div className="hidden absolute top-2.5 sm:flex w-[84%] ml-6 z-3 h-0.5 bg-gray-500"></div>
                          )}
                          <div className="mt-2 sm:pe-8 w-36">
                            <p className="text-sm font-normal text-gray-500 text-start">
                              Recce
                            </p>
                          </div>
                        </li>
                      )}
                    </React.Fragment>
                  ))
              ) : (
                <li className="relative mb-6 sm:mb-0">
                  <div className="flex items-center">
                    <div className="z-10 flex items-center justify-center w-6 h-6 border border-gray-500 rounded-full shrink-0"></div>
                    {(job[0]?.servicesNeeded.includes("Printing") ||
                      job[0]?.servicesNeeded.includes("Fabrication") ||
                      job[0]?.servicesNeeded.includes("Painting")) && (
                      <div className=" sm:flex w-full bg-gray-500 h-0.5 "></div>
                    )}
                  </div>
                  <div className="mt-2 sm:pe-8 w-36">
                    <p className="text-sm font-normal text-gray-500 text-start">
                      Recce
                    </p>
                  </div>
                </li>
              )}
            </>
          )}

          {/* manufacturing */}
          {(job[0]?.servicesNeeded.includes("Printing") ||
            job[0]?.servicesNeeded.includes("Fabrication") ||
            job[0]?.servicesNeeded.includes("Painting")) &&
            (job?.filter(
              (ele) =>
                (ele?.serviceType === "0" && ele.driverDetails) ||
                ele?.batchOfJobsForInstallationPartnerId?.dispatchStatus ==
                  "1" ||
                ele?.batchOfJobsForVendorId?.pdiStatus === "Approved" ||
                ele?.paintingJobRelatedFields?.paintingJobCompleted == true,
            ).length > 0 ? (
              job
                .filter(
                  (ele) =>
                    (ele?.serviceType === "0" && ele?.driverDetails) ||
                    ele?.batchOfJobsForInstallationPartnerId?.dispatchStatus ==
                      "1" ||
                    ele?.batchOfJobsForVendorId?.pdiStatus === "Approved" ||
                    ele?.paintingJobRelatedFields?.paintingJobCompleted == true,
                )
                .map((ele) => (
                  <React.Fragment key={ele.id}>
                    {!job[0]?.servicesNeeded?.includes("Recce") ||
                    ele.status === 2 ||
                    ele?.batchOfJobsForVendorId?.pdiStatus === "Approved" ? (
                      <li className="relative mb-6 sm:mb-0">
                        {/* Completed state */}
                        {job[0]?.servicesNeeded.includes("Installation") && (
                          <div className="hidden absolute top-2.5 sm:flex w-[84%] ml-6 z-3 h-0.5 bg-blue-500"></div>
                        )}
                        <div className="z-10 flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full shrink-0">
                          <img
                            src="/assests/images/Campaigndash/Vector.png"
                            alt="vector"
                          />
                        </div>
                        <div className="mt-2 sm:pe-8 w-36">
                          <p className="text-sm font-normal text-gray-500 text-start">
                            Supply
                          </p>
                        </div>
                      </li>
                    ) : (
                      <li className="relative mb-6 sm:mb-0">
                        {/* Incomplete state */}
                        {job[0]?.servicesNeeded.includes("Installation") && (
                          <div className="hidden absolute top-2.5 sm:flex w-full h-0.5 bg-gray-500"></div>
                        )}
                        <div className="z-10 flex items-center justify-center w-6 h-6 border border-blue-500 rounded-full shrink-0">
                          <img
                            src="/assests/images/Campaigndash/circle.png"
                            alt="circle"
                          />
                        </div>
                        <div className="mt-2 sm:pe-8 w-36">
                          <p className="text-sm font-normal text-gray-500 text-start">
                            Supply
                          </p>
                        </div>
                      </li>
                    )}
                  </React.Fragment>
                ))
            ) : (
              <li className="relative mb-6 sm:mb-0">
                {/* Default fallback */}
                <div className="flex items-center">
                  <div className="z-10 flex items-center justify-center w-6 h-6 border border-gray-500 rounded-full shrink-0"></div>
                  {job[0]?.servicesNeeded.includes("Installation") && (
                    <div className="hidden sm:flex w-full bg-gray-500 h-0.5"></div>
                  )}
                </div>
                <div className="mt-2 sm:pe-8 w-36">
                  <p className="text-sm font-normal text-gray-500 text-start">
                    Supply
                  </p>
                </div>
              </li>
            ))}

          {/* installation */}
          {job[0]?.servicesNeeded.includes("Installation") && (
            <>
              {job?.map((ele) => {
                if (ele?.serviceType == "1" && ele?.installationPartnerId) {
                  return (
                    <li className="relative mb-6 sm:mb-0" key={ele.id}>
                      <div className="flex items-center relative w-20 bottom-[1rem] ">
                        <Tooltip
                          title={
                            <div className="text-white rounded-lg p-2">
                              {/* Photo and Name */}
                              <div className="flex items-center mb-2">
                                <div className="flex items-center justify-center text-white rounded-md font-semibold">
                                  {/* Extract Initials */}
                                  <Avatar
                                    sx={{
                                      bgcolor: "#3b82f6",
                                      width: 60,
                                      height: 60,
                                    }}
                                    variant="rounded"
                                  >
                                    RV
                                  </Avatar>
                                </div>
                                <div className="ml-3">
                                  <p className="font-semibold text-white">
                                    IP Name:{" "}
                                    {ele?.installationPartnerId?.name
                                      ?.charAt(0)
                                      .toUpperCase() +
                                      ele?.installationPartnerId?.name.slice(1)}
                                  </p>{" "}
                                  {/* Replace with dynamic name */}
                                  <p className="text-white">
                                    Total Jobs done:{" "}
                                    <span className="font-bold">240</span>
                                  </p>{" "}
                                  {/* Replace dynamically */}
                                  <p className="text-white">
                                    Rating:{" "}
                                    <span className="text-blue-400">
                                      ⭐ {ele?.installationPartnerId?.rating}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          }
                          arrow
                          placement="top"
                        >
                          <img
                            src="/assests/images/Campaigndash/Icon (4).png"
                            className="cursor-pointer"
                            alt="info"
                          />
                        </Tooltip>
                        <div className="hidden sm:flex w-full bg-blue-500 h-0.5"></div>
                      </div>

                      {/* <div className="mt-2 sm:pe-8">
                                                    <p className="text-sm font-normal text-gray-500 text-center dark:text-white">
                                                      Tooltip
                                                    </p>
                                                  </div> */}
                    </li>
                  );
                }
                return null;
              })}
              {/* installation */}
              {job?.filter(
                (ele) => ele?.serviceType === "1" && ele.installationPartnerId,
              ).length > 0 ? (
                job
                  .filter(
                    (ele) =>
                      ele?.serviceType === "1" && ele?.installationPartnerId,
                  )
                  .map((ele) => (
                    <React.Fragment key={ele.id}>
                      {ele.status === 2 ? (
                        <li className="relative mb-6 sm:mb-0">
                          {/* <div className="hidden sm:flex w-[87%] ml-5 z-3 absolute top-3 bg-blue-500 h-0.5 "></div> */}
                          <div className="z-10 flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full shrink-0">
                            <img
                              src="/assests/images/Campaigndash/Vector.png"
                              alt="vector"
                            />
                          </div>

                          <div className="mt-2 sm:pe-8 w-36">
                            <p className="text-sm font-normal text-gray-500 text-start">
                              Installation
                            </p>
                          </div>
                        </li>
                      ) : (
                        <li className="relative mb-6 sm:mb-0">
                          {/* <div className="hidden absolute top-2.5 sm:flex w-[84%] ml-6 z-3 h-0.5 bg-gray-500"></div> */}

                          <div className="z-10 flex items-center justify-center w-6 h-6 border border-blue-500 rounded-full shrink-0">
                            <img
                              src="/assests/images/Campaigndash/circle.png"
                              alt="circle"
                            />
                          </div>
                          <div className="mt-2 sm:pe-8 w-36">
                            <p className="text-sm font-normal text-gray-500 text-start">
                              Installation
                            </p>
                          </div>
                        </li>
                      )}
                    </React.Fragment>
                  ))
              ) : (
                <li className="relative mb-6 sm:mb-0">
                  <div className="flex items-center">
                    <div className="z-10 flex items-center justify-center w-6 h-6 border border-gray-500 rounded-full shrink-0"></div>
                    {/* <div className="hidden sm:flex w-full bg-gray-500 h-0.5 "></div> */}
                  </div>
                  <div className="mt-2 sm:pe-8 w-36">
                    <p className="text-sm font-normal text-gray-500 text-start">
                      Installation
                    </p>
                  </div>
                </li>
              )}
              {job?.map((ele) => {
                if (ele?.serviceType === "2" && ele?.installationPartnerId) {
                  return (
                    <li className="relative mb-6 sm:mb-0" key={ele.id}>
                      <div className="flex items-center relative w-20 bottom-[1rem] ">
                        <Tooltip
                          title={
                            <div className="text-white rounded-lg p-2">
                              {/* Photo and Name */}
                              <div className="flex items-center mb-2">
                                <div className="flex items-center justify-center text-white rounded-md font-semibold">
                                  {/* Extract Initials */}
                                  <Avatar
                                    sx={{
                                      bgcolor: "#3b82f6",
                                      width: 60,
                                      height: 60,
                                    }}
                                    variant="rounded"
                                  >
                                    RV
                                  </Avatar>
                                </div>
                                <div className="ml-3">
                                  <p className="font-semibold text-white">
                                    IP Name:{" "}
                                    {ele?.installationPartnerId?.name
                                      ?.charAt(0)
                                      .toUpperCase() +
                                      ele?.installationPartnerId?.name.slice(1)}
                                  </p>{" "}
                                  {/* Replace with dynamic name */}
                                  <p className="text-white">
                                    Total Jobs done:{" "}
                                    <span className="font-bold">240</span>
                                  </p>{" "}
                                  {/* Replace dynamically */}
                                  <p className="text-white">
                                    Rating:{" "}
                                    <span className="text-blue-400">
                                      ⭐ {ele?.installationPartnerId?.rating}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          }
                          arrow
                          placement="top"
                        >
                          {" "}
                          <img
                            src="/assests/images/Campaigndash/Icon (4).png"
                            className="cursor-pointer"
                            alt="info"
                          />
                        </Tooltip>
                        <div className="hidden sm:flex w-full bg-blue-500 h-0.5"></div>
                      </div>
                    </li>
                  );
                }
                return null;
              })}
            </>
          )}
        </ol>
      </div>

      <div
        onClick={() => {
          if (matchingJob?.status !== 0) {
            setSelectedJob(matchingJob);
            setIsModalOpen(true);
          }
        }}
        className={`col-span-1 order-2 md:order-none mb-4 md:mb-0 flex justify-end 
    ${
      matchingJob?.approval?.adminStatus === -1 ||
      matchingJob?.approval?.clientStatus === -1
        ? "text-red-500 cursor-not-allowed"
        : matchingJob?.status !== 0
          ? "text-blue-500 cursor-pointer"
          : "text-gray-500 cursor-not-allowed"
    }`}
      >
        {matchingJob?.approval?.adminStatus === -1 ||
        matchingJob?.approval?.clientStatus === -1 ? (
          <div className="relative group w-fit">
            <span>Rejected Site</span>

            {/* Tooltip */}
            {(matchingJob?.approval?.adminStatus === -1 ||
              matchingJob?.approval?.clientStatus === -1) && (
              <div
                className="
      absolute 
      bottom-full 
      right-0 
      mb-2 
      hidden 
      group-hover:block
      bg-black 
      text-white 
      text-xs 
      px-3 
      py-2 
      rounded-lg 
      shadow-lg 
      whitespace-nowrap
      z-50
    "
              >
                {matchingJob?.approval?.approvalReason ||
                  matchingJob?.approval?.rejectionReason ||
                  "Rejected"}

                {/* Arrow */}
                <div
                  className="
        absolute 
        top-full 
        right-3 
        border-4 
        border-transparent 
        border-t-black
      "
                />
              </div>
            )}
          </div>
        ) : (
          `View Files`
        )}
      </div>
      <ReportModal
        selectedJob={selectedJob}
        setSelectedJob={setSelectedJob}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        CampaignDetails={CampaignDetails}
        getCampaignDetails={getCampaignDetails}
      />
    </div>
  );
};

export default ProductTimelineAccordion;
